export default __webpack_public_path__ + "static/media/kansas.29b2ec22.jpg";